export const addTotalTTC = ({ TVA, totalHT, form }) => {
  const newTVA = TVA;
  const newTotalHT = totalHT || 0;
  const newTotalTTC = TVA
    ? newTotalHT + newTotalHT * (newTVA / 100)
    : newTotalHT;

  form.setFieldValue(['rate', 'total_ttc'], newTotalTTC.toFixed(2));
};
